import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "p-2" }
const _hoisted_3 = { class: "p-2" }

import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElDialog, ElMessageBox } from 'element-plus';
    import { useStore } from 'vuex';
    import { AdBanner } from '@/services/types/adBanner';
    import AdBannerView from '@/components/modals/views/AdBannerView.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'adBannersView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const showDialog = ref<boolean>(false)
    const data = ref<Array<AdBanner>>()
    const adBanner = ref<AdBanner | null>(null)

    const getAdBanners = async () => {
        const res = await Api.get('/admin/ad-banners')
        if (res.status == 200) {
            data.value = res.data.adBanners
            console.log(res)
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
    }

    const openAdBanner = (a: AdBanner) => {
        showDialog.value = true
        adBanner.value = a
    }

    const hide = (a?: AdBanner) => {
        if (a) {
            const toEdit = data.value?.find((ad) => ad.id == a.id)
            if (toEdit) {
                toEdit.description = a.description
                toEdit.expires_at = a.expires_at
                toEdit.image = a.image
                toEdit.position = a.position
                toEdit.small_text = a.small_text
                toEdit.title = a.title
                toEdit.updated_at = a.updated_at
                toEdit.url = a.url
            }
        }
        showDialog.value = false
        adBanner.value = null
    }
    
    const deleteBanner = async (id: number) => {
        loading.value = true
        if (confirm('Deseja realmente eliminar?')) {
            const res = await Api.delete(`/admin/ad-banners/${id}`)
            if (res.status == 200) {
                await getAdBanners()
            } else {
                ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
            }
        }
        loading.value = false
    }

    onBeforeMount(async () => {
        await getAdBanners()
        loading.value = false
    })

    const store = useStore()
    store.watch((s, g) => g.openModal, async (val, oldVal) => {
        if (oldVal == 1) {
            await getAdBanners()
        }
    })

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_card, { header: "Banners publicitarios" }, {
        default: _withCtx(() => [
          _createVNode(PersonalTable, {
            loading: loading.value,
            height: 450,
            showRows: 10,
            cols: [
                {label: 'Nome', prop: 'title'},
                {label: 'link', prop: 'url'},
                {label: 'Ordem', prop: 'position'},
                {label: 'Texto', prop: 'small_text'},
            ],
            data: data.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "Expira em",
                "class-name": "auto",
                "min-width": 150
              }, {
                default: _withCtx((data) => [
                  _createTextVNode(_toDisplayString(new Date(data.row.expires_at).toLocaleString()), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "Cadatrado em",
                "class-name": "auto",
                "min-width": 100
              }, {
                default: _withCtx((data) => [
                  _createTextVNode(_toDisplayString(new Date(data.row.created_at).toLocaleString()), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "Acções",
                "class-name": "auto"
              }, {
                default: _withCtx((data) => [
                  _createElementVNode("span", _hoisted_2, [
                    _createVNode(_component_el_button, {
                      onClick: ($event: any) => (openAdBanner(data.row)),
                      type: "primary",
                      icon: "View",
                      title: "Ver mais"
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("span", _hoisted_3, [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      icon: "Delete",
                      title: "Eliminar",
                      onClick: ($event: any) => (deleteBanner(data.row.id))
                    }, null, 8, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading", "data"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(ElDialog), {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showDialog).value = $event)),
      "show-close": "",
      onClose: hide
    }, {
      default: _withCtx(() => [
        (adBanner.value)
          ? (_openBlock(), _createBlock(AdBannerView, {
              key: 0,
              "ad-banner": adBanner.value,
              onClose: hide
            }, null, 8, ["ad-banner"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})